import { Download, X } from 'lucide-react';
import { PERCUSSION, findInstrument, noteName } from '@/lib/pitch';

export const SharedTuningBanner = ({ shared, onAccept, onDismiss }) => {
  const isKit = shared.kind === 'kit';
  const instrumentName = findInstrument(shared.instrumentId).name;
  const notes = isKit
    ? shared.notes.map((m, i) => `${PERCUSSION[shared.instrumentId][i].label} ${noteName(m, false)}`).join(' · ')
    : shared.notes.map((m) => noteName(m, false)).join(' ');
  return (
    <section data-testid="tuner-shared-banner" className="rounded-2xl border border-sky-400/40 bg-sky-400/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-[0.3em] text-sky-300">{isKit ? 'Note tamburi condivise' : 'Accordatura condivisa'} · {instrumentName}</div>
        <div data-testid="tuner-shared-name" className="font-bebas text-2xl tracking-wide truncate">{isKit ? instrumentName : shared.name}</div>
        <div data-testid="tuner-shared-notes" className="text-xs font-mono text-white/60">{notes}</div>
        {isKit && <div className="text-[11px] text-white/45 mt-1">Sostituiranno le tue note attuali per questo strumento.</div>}
      </div>
      <div className="flex gap-2">
        <button data-testid="tuner-shared-accept" onClick={onAccept} className="h-11 px-4 rounded-full bg-sky-400 text-black text-xs font-semibold uppercase tracking-[0.2em] inline-flex items-center gap-2 active:scale-95 transition-transform">
          <Download className="w-4 h-4" /> {isKit ? 'Importa' : 'Aggiungi'}
        </button>
        <button data-testid="tuner-shared-dismiss" aria-label="Ignora" onClick={onDismiss} className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/5">
          <X className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
};
